import "./Home.css";
import Logo from "../../Images/applogo.png";
import mobileLogo from "../../Images/mobile.png";
import playstoreimg from "../../Images/playstore.png";

const Home = () => {
  return (
    <div>
      <div id="myHeader" class="header">
        <div class="logo">
          <img src={Logo} className="main-image"></img>
          <div class="header-right"></div>
        </div>
      </div>

      {/* <div
        className="row"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="col">
          <img
            src={mobileLogo}
            style={{ width: "40%", height: "20%" }}
            alt="Mobile Logo"
          />
        </div>
        <div className="col" style={{ textAlign: "center" }}>
          <h1>
            Stay Informed and Elevate Your Knowledge and Career with Insight
            Headlines!
          </h1>
        </div>
      </div> */}

      <div className="app">
        <img
          src={mobileLogo}
          style={{ objectFit: "contain", width: "70%", maxWidth: "350px" }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "40%",
          }}
        >
          <div>
            <h1 style={{ color: "#369af8" }}>
              Stay Informed and Elevate Your Knowledge and Career with Insight
              Headlines!
            </h1>
            <p>
              Discover a world of concise and up-to-the-minute news updates in
              business, tech, sports, and science, all in one convenient app.
              Whether you're a news enthusiast or a professional looking to
              boost your career, Insight Headlines has you covered.
            </p>
          </div>

          <a href="https://play.google.com/store/apps/details?id=com.app.insightheadlines">
            <img
              src={playstoreimg}
              style={{
                width: "10rem",
                height: "4.01205rem",
                objectFit: "contain",
              }}
            />
          </a>
        </div>
      </div>
    </div>
  );
};
export default Home;
